import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { PureComponent } from 'react';
import { Nav, NavItem } from 'react-bootstrap/lib';
import { LinkContainer } from 'react-router-bootstrap/lib';
import buildMenu from './menuBuilder';

class InventoryNav extends PureComponent {
  renderMenuItem = ({ url, name }) => (
    <LinkContainer to={url} key={url}>
      <NavItem>{name}</NavItem>
    </LinkContainer>
  );

  render() {
    const { user } = this.props;
    const menu = buildMenu(user);
    return <Nav bsStyle="tabs">{menu.map(this.renderMenuItem)}</Nav>;
  }
}

InventoryNav.propTypes = {
  user: PropTypes.object,
};

const mapStateToProps = ({ user }) => ({
  user: user.currentUser,
});

export default connect(mapStateToProps)(InventoryNav);
